import { rgba } from 'polished';

export type CustomTheme = {
  colors: {
    [key: string]: any;
  };
  icons: {
    [key: string]: any;
  };
  siteHeaderHeight: string;
  pageHeaderHeight: string;
  sideMenuWidth: string;
  sideMenuOpenWidth: string;
  footerHeight: string;
  pageContentPaddingTop: string;
  pageContentPaddingBottom: string;
  fonts: {
    [key: string]: any;
  };
};

export const screenSizes = {
  extraWideScreen: 1750,
  wideScreen: 1200,
  desktop: 992,
  tablet: 768,
  phone: 0 /* 320 */
};

const styleConstants = {
  siteHeaderHeight: '90px',
  pageHeaderHeight: '50px',
  sideMenuWidth: '50px',
  sideMenuOpenWidth: '155px',
  footerHeight: '62px',
  pageContentPaddingTop: '15px',
  pageContentPaddingBottom: '5px',

  icons: {
    facebookCircle: '"\\e96a"',
    newShare: '"\\e965"',
    facebookF: '"\\e969"',
    newLink: '"\\e966"',
    menuItemHanshake: '"\\e901"',
    magnifyGlass: '"\\e902"',
    chat: '"\\e903"',
    menuItemReports: '"\\e904"',
    menuItembell: '"\\e905"',
    menuItemMembers: '"\\e906"',
    menuItemNews: '"\\e907"',
    menuItemInstantInventory: '"\\e908"',
    handshake: '"\\e909"',
    sort: '"\\e90b"',
    arrow: '"\\e90d"',
    menuItemDiamond: '"\\e90e"',
    menuItemJewelry: '"\\e90f"',
    menuItemPrices: '"\\ea00"',
    menuR: '"\\e910"',
    menuItemAuctions: '"\\e911"',
    menuItemSupport: '"\\e912"',
    check: '"\\e91a"',
    menuItemBuyRequests: '"\\e90a"',
    x: '"\\e90c"',
    focus: '"\\e913"',
    erase: '"\\e9140"',
    calculator: '"\\10ffff"',
    menuItemMessages: '"\\e914"',
    rapnetLogo: '"\\e918"',
    rapaportLogo: '"\\e9ff"',
    referAFriend: '"\\e916"',
    save: '"\\e952"',
    productUpdates: '"\\e917"',
    exportPdf: '"\\e9a7"',
    tools: '"\\e915"',
    logout: '"\\e919"',
    showSelected: '"\\e900"',
    openCloseAll: '"\\e91b"',
    compare: '"\\e91c"',
    print: '"\\e91f"',
    custom: '"\\e920"',
    techNet: '"\\e91d"',
    designIcon: '"\\e95a"',
    remote: '"\\e91e"',
    trackStar: '"\\e922"',
    addPlus: '"\\e921"',
    contactSellerEnvelop: '"\\e923"',
    exclamationCircle: '"\\e924"',
    ellipsis: '"\\e986"',
    helpArticles: '"\\e925"',
    menuItemsAddons: '"\\e926"',
    chatWidgetIcon: '"\\e927"',
    filter: '"\\e928"',
    pencil: '"\\e920"',
    pencilHollow: '"\\e9d2a"',
    addNote: '"\\e933e"',
    contactSeller: '"\\e92d"',
    createaList: '"\\e9a1"',
    trackedJewelry: '"\\e9a6"',
    showOnlySelected: '"\\e9a5"',
    addSelectedtoList: '"\\e9a4"',
    emailSelected: '"\\e9a3"',
    exportSelected: '"\\e9a2"',
    external: '"\\e938"',
    externalLink: '"\\e93b"',
    delete: '"\\e93c"',
    hollowPencil: '"\\e9aed"',
    draggebleArrow: '"\\ee929"',
    excel: '"\\e929"',
    search: '"\\e902"',
    dashboardIconBuyRequest: '"\\e92f"',
    dashboardIconHandshake: '"\\e92e"',
    dashboardIconEnvelope: '"\\e92d"',
    dashboardIconRing: '"\\e92c"',
    dashboardIconDiamond: '"\\e92b"',
    dashboardIconBuyRequestBig: '"\\e92a"',
    imagePlaceholder: '"\\e940"',
    link: '"\\e941"',
    clock: '"\\e930"',
    addToCompare: '"\\e931"',
    supplierComentSection: '"\\e9b2"',
    linksSection: '"\\e9b1"',
    mail: '"\\e932"',
    media: '"\\e934"',
    groups: '"\\e996"',
    certificate: '"\\e935"',
    diamondDuplicates: '"\\e936"',
    translator: '"\\e937"',
    tableView: '"\\e939"',
    phone: '"\\ee938"',
    deleteShared: '"\\e93e"',
    dashboardIconPrimarySupplier: '"\\ee939"',
    primarySupplierCrown: '"\\ee940"',
    table: '"\\e93a"',
    share: '"\\e93d"',
    pinContact: '"\\e99e"',
    assignUser: '"\\e942"',
    fileAttchment: '"\\e943"',
    fileDoc: '"\\e944"',
    fileExcel: '"\\e945"',
    removeSelected: '"\\e9a8"',
    playVideo: '"\\e946"',
    sendMessage: '"\\e947"',
    location: '"\\e948"',
    cursor: '"\\e949"',
    email: '"\\e94a"',
    fax: '"\\e93f"',
    approved: '"\\e959"',
    additionalInfo: '"\\e958"',
    whatsapp: '"\\e94c"',
    diamondItem: '"\\e957"',
    whatsappPhone: '"\\e94d"',
    jobTitle: '"\\e94b"',
    calendar: '"\\e94e"',
    multipleDiamonds: '"\\e94f"',
    multipleJewelry: '"\\e950"',
    showlistings: '"\\e951"',
    log_email: '"\\e953"',
    log_meeting: '"\\e954"',
    log_call: '"\\e955"',
    threeDots: '"\\e956"',
    info: '"\\e958"',
    mobileScreen: '"\\e95b"',
    computerScreen: '"\\ee941"',
    copy: '"\\ee942"',
    filledStar: '"\\e95c"',
    emptyStar: '"\\e95d"',
    nextIcon: '"\\e9b9"',
    slimPlus: '"\\e95e"',
    camera: '"\\e95f"',
    tag: '"\\e96d"',
    addNewItem: '"\\e960"',
    checkCircle: '"\\e961"',
    xCircle: '"\\e962"',
    formView: '"\\e963"',
    curvedArrow: '"\\e964"',
    addContact: '"\\e96b"',
    contactIcon: '"\\e96c"',
    ringIcon: '"\\e977"',
    braceletsIcon: '"\\e972"',
    broochesIcon: '"\\e975"',
    pendantsIcon: '"\\e974"',
    cuffLinksIcon: '"\\e978"',
    earringsIcon: '"\\e971"',
    cart: '"\\e9d6"',
    necklacesIcon: '"\\e973"',
    watchesIcon: '"\\e98f"',
    otherIcon: '"\\e96f"',
    deliveryLocation: '"\\e9b3"',
    csvIcon: '"\\ee965"',
    ringType: '"\\e996e"',
    braceletsType: '"\\e995e"',
    earringsType: '"\\e994e"',
    pendantsType: '"\\e999e"',
    necklacesType: '"\\e998e"',
    watchesType: '"\\e993e"',
    broochesPinsType: '"\\ee9b4"',
    cuffLinksType: '"\\ee9b5"',
    emailCampaign: '"\\ee96b"',
    groupImages: '"\\e97a"',
    importFromCloud: '"\\e970"',
    importVideo: '"\\e96e"',
    openFolder: '"\\e979"',
    disconnect: '"\\e97b"',
    expand: '"\\e97c"',
    predefinedCatalog: '"\\e98d"',
    ownRingSettings: '"\\e98c"',
    download: '"\\e97d"',
    connectPeople: '"\\e985"',
    gallery: '"\\e97f"',
    list: '"\\e97e"',
    ringBuilder: '"\\e98b"',
    raplabBanner: '"\\e980"',
    pdf: '"\\e981"',
    gear: '"\\e982"',
    collaborators: '"\\e98aa"',
    quote: '"\\e988a"',
    leaveList: '"\\e989a"',
    padlock: '"\\e983"',
    csvDownload: '"\\e9b8"',
    itemPage: '"\\e984"',
    viewsAndShares: '"\\e985"',
    addSelectedItems: '"\\e987a"',
    corporate: '"\\e987"',
    doubleCheck: '"\\e988"',
    csvFileIcon: '"\\ee987"',
    processingIcon: '"\\ee988"',
    folder: '"\\e989"',
    leftArrow: '"\\e98a"',
    reply: '"\\e9af"',
    ringSettings: '"\\e98e"',
    shinyPackage: '"\\e990"',
    brilliantPackage: '"\\e991"',
    sparklingPackage: '"\\e992"',
    lock: '"\\e9999"',
    downloadFile: '"\\e997"',
    basket: '"\\e995"',
    monitorGraph: '"\\e994"',
    horn: '"\\e993"',
    questionMark: '"\\e998"',
    publishIcon: '"\\ef998"',
    unpublishIcon: '"\\ef996"',
    helpReferAFriend: '"\\e999"',
    helpUpdates: '"\\e99a"',
    helpIdeas: '"\\e99b"',
    helpTools: '"\\e99c"',
    gia: '"\\e99d"',
    doublePhoto: '"\\e99f"',
    doublePhotoCircle: '"\\e9a0"',
    rapnetVerified: '"\\e9a9"',
    popout: '"\\ee58"',
    tableExpand: '"\\e9aa"',
    tableShowSelected: '"\\e9ab"',
    respond: '"\\e9ac"',
    contactSelected: '"\\e9ad"',
    eye: '"\\e9ae"',
    searchDiamond: '"\\e9b0"',
    respondEmpty: '"\\e9af"',
    expandToggle: '"\\e9b4"',
    collapseToggle: '"\\e9b5"',
    addToBR: '"\\e9b6"',
    contactSellerList: '"\\e9b7"',
    profileIcon: '"\\e9d2"',
    round: '"\\ee999"',
    pear: '"\\ee994"',
    oval: '"\\ee993"',
    marquise: '"\\ee990"',
    heart: '"\\ee996"',
    radiant: '"\\ee995"',
    princess: '"\\ee991"',
    emerald: '"\\ee998"',
    asscher2: '"\\e9ca"',

    asscher: '"\\e9cb"',
    squareEmerald: '"\\ed9ce"',
    asscherSqEm: '"\\e9c1"',

    squareRadiant: '"\\ed9cf"',
    cushionAll: '"\\e9c2"',
    cushionBrill: '"\\e9ce"',
    cushionMod: '"\\e9c9"',
    cushion: '"\\ee992"',
    epaulette: '"\\e9c0"',
    europeanCut: '"\\e9cd"',

    oldMiner: '"\\e9cc"',
    baguette: '"\\ed9cd"',
    briolette: '"\\ed9b8"',
    bullets: '"\\ed9b9"',
    calf: '"\\ed9ba"',
    flanders: '"\\ed9bb"',
    halfMoon: '"\\e9c4"',
    hexagonal: '"\\ed9c0"',
    kite: '"\\ed9b7"',
    lozenge: '"\\ed9c1"',
    octagonal: '"\\ed9c2"',
    pentagonal: '"\\ed9c3"',
    rose: '"\\ed9c4"',
    shield: '"\\ed9c5"',
    square: '"\\ed9c6"',
    star: '"\\ed9cc"',

    taperedBaguette: '"\\ed9c7"',
    taperedBullet: '"\\ed9c8"',
    trapezoid: '"\\ed9c9"',
    triangular: '"\\ed9ca"',
    trilliant: '"\\ed9cb"',
    circularBrilliant: '"\\ed9a8"',
    cabochon: '"\\eae01"',

    uploadchain: '"\\e9ba"',
    uploadfolder: '"\\e9bb"',
    uploadimage: '"\\e9bc"',
    fancyCrown: '"\\ec9ba"',
    cameraAlt: '"\\ec9cb"',
    dealer: '"\\ec9bb"',
    docsPdf: '"\\ea997"',
    smileFace: '"\\ec9be"',
    sadFace: '"\\ec9bf"',
    neutralFace: '"\\ec9bd"',
    russianOrigin: '"\\e9bd"',
    verifiedOrigin: '"\\e9bf"',
    adminReviewFlag: '"\\ee9c1"',
    greenstar: '"\\e9c5"',
    heartEmpty: '"\\e9c7"',
    heartFilled: '"\\e9cf"',
    resize: '"\\e9d3"',
    diamondDiagram: '"\\ee9d4"',
    similarDiamonds: '"\\ee9d5"',
    addCart: '"\\e9d5"',
    americanExpress: '"\\e9d7',
    masterCard: '"\\e9e4"',
    visa: '"\\e9f4"',
    rightArrow: '"\\e98a"',
    v360: '"\\e9fc"',
    zoom: '"\\e9fd"',
    twitterX: '"\\e9fe"',

    // new set of icons (gemstones related)
    circleplusinsquare: '"\\eea22"',
    phoneAlt: '"\\eea01"',
    viewAlt: '"\\eea02"',
    verified: '"\\eea03"',
    zoomMinus: '"\\eea04"',
    emptyCalendar: '"\\eea05"',
    doublePlus: '"\\eea06"',
    downloadAlt: '"\\eea07"',
    world: '"\\eea08"',
    marker: '"\\eea09"',
    menuAlt: '"\\eea0a"',
    sortAlt: '"\\eea0b"',
    listAlt: '"\\eea0c"',
    attention: '"\\eea0d"',
    linkAlt: '"\\eea0e"',
    arrowRight: '"\\eea23"',
    arrowLeft: '"\\eea24"',
    gemstone: '"\\eea12"',
    videoIconAlt: '"\\eba01"',
    uploadIconAlt: '"\\eba02"',
    imageIconAlt: '"\\eba03"',
    listView: '"\\eba04"',
    connectMedia: '"\\eba05"',
    gridView: '"\\eba06"',
    zipIcon: '"\\eaa01"',
    tagIcon: '"\\ea01"',

    other: {
      jewelryFeatures: '"\\ed00a"',
      jewelryMeasurements: '"\\ed00b"',
      jewelryDiamonds: '"\\ee56"',
      jewelryGems: '"\\ee21"',
      heartEmpty: '"\\e900"',
      heartIdle: '"\\e901"',
      heartFull: '"\\e930"',
      twitter: '"\\e92e"',
      facebook: '"\\e92c"',
      instagram: '"\\e92f"',
      mail: '"\\e931"',
      magnifyGlass: '"\\e902"',
      menuItembell: '"\\e905"',
      calculator: '"\\10ffff"',
      sort: '"\\e90b"',
      x: '"\\e90c"',
      excel: '"\\e929"',
      filter: '"\\e928"',
      custom: '"\\e920"',
      arrowBack: '"\\fffd"',
      download: '"\\e903"',
      upload: '"\\e904"',
      trash: '"\\e9ac"',
      loop: '"\\ea2e"',
      linkedin: '"\\ec906"',
      twitterSquare: '"\\ec907"'
    }
  },

  fonts: {
    FunnelDisplay: "'Funnel Display', 'Montserrat-Bold', sans-serif",
    interSans: "'Inter', 'Montserrat-Regular', sans-serif",
    interSansMedium: "'Inter', 'Montserrat-Medium', sans-serif",
    interSansSemiBold: "'Inter', 'Montserrat-SemiBold', sans-serif",
    interSansBold: "'Inter', 'Montserrat-Bold', sans-serif",
    montserratBold: "'Montserrat-Bold', sans-serif",
    montserratSemiBold: "'Montserrat-SemiBold', sans-serif",
    montserratRegular: "'Montserrat-Regular', sans-serif",
    montserratMedium: "'Montserrat-Medium', sans-serif",
    MontserratLight: "'Montserrat-Light', sans-serif",
    montserratLight: "'Montserrat-Light', sans-serif",
    other: {
      ITCAvantGardeStd_Light: "'ITCAvantGardeStd-Bk', 'Arial', 'sans-serif'",
      Montserrat_More_Regular: "'Montserrat-More-Regular', 'Arial', 'sans-serif'",
      openSansRegular: "'OpenSans-Regular', Arial, sans-serif"
    }
  }
};

export const theme: CustomTheme = {
  colors: {
    red: '#C10230',
    green: '#00BA88',
    yellow: '#FFC700',
    hoverRed: '#B4002B',
    darkRed: '#A20026',
    gold: '#E4A917',
    orange: '#f57b22',
    white: '#ffffff',
    hoverWhite: '#e6e6e6',
    inputBorderGrey: '#CCD6E2',
    inputBackgroundGrey: '#FDFDFD',
    darkGray: '#f2f2f2',

    tabHoverGray: '#f9f9f9',
    placeholderGray: '#808080',
    siteGrey: '#F0F0F0',
    focusShadowSiteGrey: rgba(112, 112, 112, 0.2), // darken 50% and .2 opacity
    siteGrayLight: rgba(240, 240, 240, 0.5), // lighten 50%
    hoverSiteGrey: '#e3e3e3', // darken 5%
    hoverBorderSiteGrey: '#d6d6d6', // darken 10%

    siteBlue: '#009ED3',
    siteDarkBlue: '#41a6d1',
    siteBlueLight: rgba(0, 158, 211, 0.1),
    focusShadowSiteBlue: rgba(0, 185, 247, 0.5), // lighten 7% and .5 opacity
    hoverBackgroundSiteBlue: '#008bb9', // darken 5%
    hoverBorderSiteBlue: '#0078a0', // darken 10%

    siteIndigo: '#5246E5',
    siteIndigoLight: '#EEEDFD',
    siteIndigoLighter: '#F5F4FF',
    siteIndigoHover: '#4338CA',
    siteIndigoBorder: '#D9D6F8',
    siteCardBackground: '#F4F4F6',
    siteCardBorder: '#E6E6EA',

    contactsGrey: '#7C7C7C',
    listsGrey: '#676767',
    disableFont: '#A7A7A7',
    toggleStripLightGrey: '#F7F7F7',
    toggleSwitchGrey: '#9D9D9D',
    toggleSwitchGreyBackground: '#B9B9B9',
    dividerGrey: '#F2F2F2',
    lightGrey: '#d0d0d0',
    lightGrey2: '#d1d1d1',
    darkMode: '#1B2436',
    darkModeAlt: '#2C3548',
    darkModeHover: '#404B62',
    darkExpandDetails: '#485369',
    darkModeInnerTable: '#6D7587',
    darkTableClikedCheck: '#1F2C4A',
    darkTableCheckboxSelected: '#30487C',
    darkTableRowVisited: '#182D5D',
    tabGrey: '#E3E3E3',
    siteBlack: '#434343',
    siteBlackLight: rgba(67, 67, 67, 0.6),
    tabHoverGrey: '#C1C1C1',
    siteNavy: '#00386E',
    siteNavyHover: '#15538a',
    overlayGrey: `rgba(41, 82, 130, 0.39)`,
    black: '#000000',
    siteVeryLightNavy: '#E7EDF8',
    siteLightNavy: '#D3DEF2',
    siteDarkNavy: '#062C4D',
    golden: '#E4B92E',
    hoverBackgroundSiteDarkNavy: '#041e35',
    hoverBorderSiteDarkNavy: '#02111e',
    focusShadowSiteDarkNavy: rgba(9, 63, 110, 0.5),
    tableHeaderColHoverBlue: '#D6EDF5',
    buttonGreen: '#00ba88',
    iconBackgroundGrey: '#343434',
    siteLightBlack: rgba(67, 67, 67, 0.52),
    draggIconGrey: '#b4b4b4',
    buttonBlue: '#039ED3',
    lightBlack: '#333333',
    dropdownBorder: '#ededed',
    tableHeaderGrey: '#707070',
    carouselButton: 'rgba(215, 215, 215, 0.9)',
    headerGrey: '#505050',
    itemBuy: '#FF7C7C',
    lightSiteBlue: '#E7F5FA',
    paginationGrey: '#848484',
    tableAction: 'rgba(242, 242, 242, 0.3)',
    tableRowOpened: '#E0F4FA',
    tableHoverRow: '#DDDDDD',
    tableRowAlt: 'rgba(255, 255, 255, 0.2)',
    tableScrollArrow: '#919191',
    boxBorder: '#C9C9C9',
    activeTag: '#F4F0F0',
    hoveredTag: '#E5E5E5',
    boxShadow: '#00000029',
    turquoise: 'turquoise',
    blurShadow: '#00000080',
    hoverSelectOptionGrey: '#f1f1f1',
    focusSelectOptionGrey: '#e8e8e8',
    notificationBlue: '#8ab4f8',
    tradeSellItem: '#54e6ca',
    tradeBuyItem: '#ff7c7c',
    itemListHover: '#eeeeee',
    dateTextGray: '#767676',
    chatBackground: '#f8f8f8',
    borderGray: '#dedede',
    assignAvater: '#868686',
    boxShadowBottom: '#0000001a',
    giaGold: '#8b7157',
    brandRed: '#d41f30',
    itemType: '#BCC9D8',
    lightOrange: '#FFAF5F',
    siteLightBlue: '#00b0ed',
    brandLightGray: '#F3F3F3',
    greenstar: '#00931D',
    searchRed: '#ff0000',
    planPurple: '#AF3D8E',
    planGreen: '#23A456',
    settingsGreen: '#23d438',

    promotedTable: {
      blue: '#F2F9FC',
      borderBlue: '#CEEBF6'
    },

    tagColorSelector: {
      lightSlateBlue: '#A56EFF',
      deepBlue: '#00386E',
      purple: '#CC00AD',
      orange: '#FF717C',
      yellow: '#F7B144',
      green: '#00BA88'
    },
    tableView: {
      compact: {
        border: '#777777',
        headerText: '#707070'
      },
      largeFonts: {
        rowOdd: '#CBCBCB'
      }
    },

    marketingEmails: {
      label: '#505050'
    },

    searchResult: {
      position: '#D9FFEE',
      mainDuplicate: '#0EBA99',
      otherDuplicate: '#008067',
      otherDuplicateBg: '#DEEFEB',
      promoted:
        'transparent linear-gradient(-90deg, #009ED3 0%, #00386E 100%) 0% 0% no-repeat padding-box',
      promotedRow: '#CDE5F0',
      promotedRowDark: '#293E69',
      promotedBottomLine: '#009ED343',
      promotedHover: '#E0F2FA',
      promotedSelected: '#9DC8DB',
      expanded: '#AEC7DE',
      sellerIsAccount: '#FDF3DB',
      priceValues: '#363636'
    },

    diamondUpload: {
      purple: rgba(211, 222, 242, 1),
      grey: '#707070',
      borderGrey: rgba(112, 112, 112, 0.17),
      sectionGrey: '#CCD6E2'
    },

    jewelry: {
      grey: '#818a94',
      text: '#363636',
      iconGrey: '#B2B2B2',
      optionSelected: '#E8F1FA',
      lighBlue: '#D6E5F7',
      activeSectionBackground: '#EFF5FC'
    },

    greenDashboard: '#26E292',

    accountsByCountryDashboard: {
      yellow: '#F0D123',
      pink: '#F083CA',
      red: '#FF9191',
      blue: '#009ED3',
      green: '#54D3AF'
    },

    viewImageBlue: rgba(0, 158, 211, 0.2),

    announcementBars: {
      primary: '#009ed3',
      neutral: '#8f8f8f',
      orange: '#f57b22'
    },
    dashboard: {
      blueOne: '#009ED3',
      blueTwo: '#006EA3',
      blueThree: '#00679D',
      blueFour: '#003B71',
      pinkOne: '#F51C5B',
      pinkTwo: '#F87772',
      pinkThree: '#F98577',
      pinkFour: '#FCE08E',
      greenOne: '#0DBA99',
      greenTwo: '#4BD0AC',
      greenThree: '#54D3AF',
      greenFour: '#96EAC3',
      chartYellow: '#F0D123',
      chartRed: '#FF9191',
      chartPurple: '#B520E2',
      chartGreen: '#00BA88',
      chartBrown: '#BA4A00',
      chartOrange: '#E69138'
    },
    instantInventory: {
      tabText: '#CCCCCC',
      tabShadow: '#00000041',
      widgetShadow: '#0000000F'
    },

    wizard: {
      tabText: '#CCCCCC',
      tabShadow: '#00000041',
      widgetShadow: '#0000000F'
    },

    v360Player: {
      disabled: '#DCDCDC',
      border: '#DCE3EB'
    },

    metalTypes: {
      white:
        'transparent linear-gradient(180deg, #E5E5E5 0%, #C6C6C6 100%) 0% 0% no-repeat padding-box',
      yellow:
        'transparent linear-gradient(180deg, #EFE491 0%, #D0AC34 100%) 0% 0% no-repeat padding-box',
      rose: 'transparent linear-gradient(180deg, #F2D0D0 0%, #E69191 100%) 0% 0% no-repeat padding-box',
      platinum:
        'transparent linear-gradient(180deg, #D0D0D0 0%, #959595 100%) 0% 0% no-repeat padding-box',
      silver:
        'transparent linear-gradient(180deg, #E5E5E5 0%, #C6C6C6 100%) 0% 0% no-repeat padding-box'
    },

    tooltip: {
      red: '#F54545'
    },
    search: {
      boxGrey: '#DCE3EB'
    },

    lists: {
      dateText: '#363636',
      titleText: '#222222',
      subTitleText: '#676767'
    },

    notes: {
      yellow: '#FFD95A',
      red: '#F54545',
      blue: '#90CCFF',
      green: '#84F095',
      purple: '#E65AFF',
      orange: '#FFAC4B'
    },

    dark: {
      sitePrimary: '#22252B',
      siteSecondary: '#01866d',
      focusShadowSiteGrey: rgba(112, 112, 112, 1)
    },

    other: {
      red: '#C10230',
      black: '#000000',
      jewelryItemDetailsBG: '#f1f2f2',
      placeholderGrey: '#aaa',
      jewelryPrimaryBtnColor: '#2699fb',
      jewelryHotIconColor: '#d23d2f',
      jewelryDividerColor: '#35393d',
      jewelryItemColorBg: '#efefef',
      instagramIconBgColor:
        'transparent linear-gradient(180deg, #dd1c89 0%, #ff6159 46%, #fe8e3f 66%, #fbce0e 100%) 0% 0% no-repeat padding-box',
      mailIconBgColor: '#7c8b90',
      twitterIconBgColor: '#76a9ea',
      facebookIconBgColor: '#475993',
      jewlryItemFooterGrey: '#756e6e',
      countDownTimerGrey: '#505050',
      opacityGreen: rgba(0, 186, 136, 0.15),
      greenBidButton: '#00ba88'
    },

    facebook: {
      facebookDarkBlue: '#3b5999',
      facebookShareBlue: '#1877f2'
    },

    groups: {
      grey: '#ACACAC'
    },

    emailVerify: {
      red: '#D2002D'
    },

    profile: {
      twitter: '#2CAEF4',
      linkedIn: '#0A66C2',
      facebook: '#1A76F2',
      red: '#C0012F'
    },
    licenseAgreement: {
      lightBlack: '#555555'
    },
    carousel: {
      arrowGrey: '#5d6164',
      dot: '#cccccc',
      dotSelected: '#707070'
    },
    buynow: {
      navyBackground: '#00508b',
      animationBackground: '#01386E',
      yellow: '#fcd04b',
      explanations: '#2C2C2C'
    },
    // new table style and borders
    border: {
      default: '#DCE3EB',
      hover: '#999999',
      active: '#00508B',
      blueHover: '#BFD3E2',
      bluePressed: '#80A8C5',
      disabled: '#E6E6E6',
      error: '#FFFFFF',
      ghosted: '#FFFFFF',
      table: rgba(0, 0, 0, 0.1),
      tableDark: rgba(0, 0, 0, 0.2)
    },
    table: {
      default: '#FFFFFF',
      striped: '#FAFAFA',
      hovered: '#E6F6FB',
      selected: '#D9D9D9',
      header: '#F2FAFD'
    },

    gemstones: {
      selected: '#F2FAFD',
      dropzone: 'rgba(0, 158, 211, 0.05)',
      success: '#07A17A',
      error: '#C10230',
      sliderArrow: rgba(256, 256, 256, 0.75),
      overlay: rgba(0, 0, 0, 0.4),
      tableRowHover: '#009ED31A',

      content: {
        primary: '#000000',
        tertiary: '#707070',
        disabled: '#999999'
      },
      background: {
        gray: '#F8F8F8'
      }
    }
  },
  ...styleConstants
};
